// src/locales/en/users.js
export const users = {
    
    manageTeamMembers: "உங்கள் குழு உறுப்பினர்கள் மற்றும் அவர்களின் அணுகலை நிர்வகிக்கவும்",
    loadingUsers: "பயனர்கள் ஏற்றப்படுகின்றன...",
    loadingUsersDesc: "பயனர் தரவைப் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    unableToLoadUsers: "பயனர்களை ஏற்ற முடியவில்லை",
    searchUsersPlaceholder: "பெயர், மின்னஞ்சல் மூலம் பயனர்களைத் தேடுங்கள்...",
    allStatus: "அனைத்து நிலை",
    allRoles: "அனைத்து பங்குகள்",
    role: "பங்கு",
    show: "காட்டு",
    perPage: "ஒரு பக்கத்திற்கு",
    noUsersFound: "பயனர்கள் கிடைக்கவில்லை",
    noUsersFoundDesc: "உங்கள் தற்போதைய தேடல் மற்றும் வடிகட்டி அளவுகோல்களுடன் பொருந்தும் பயனர்கள் இல்லை.",
    noUsersYet: "இன்னும் பயனர்கள் இல்லை",
    noUsersYetDesc: "உங்கள் முதல் பயனரைச் சேர்ப்பதன் மூலம் உங்கள் குழுவை உருவாக்கத் தொடங்குங்கள்.",
    addFirstUser: "முதல் பயனரைச் சேர்",
    user: "பயனர்",
    assignments: "பணிகள்",
    userAvatarAlt: "{{name}} அவதாரம்",
    noRoleAssigned: "பங்கு ஒதுக்கப்படவில்லை",
    shopCount: "{{count}} கடை",
    warehouseCount: "{{count}} கிடங்கு",
    noAssignments: "பணிகள் இல்லை",
    viewDetails: "விவரங்களைப் பார்",
    editUser: "பயனரைத் திருத்து",
    activate: "செயல்படுத்து",
    deactivate: "செயலிழக்க",
    confirmStatusChange: "\"{{userName}}\" பயனரை {{action}} செய்ய விரும்புகிறீர்களா?",
    statusUpdateSuccess: "பயனர் \"{{userName}}\" வெற்றிகரமாக {{status}} செய்யப்பட்டது.",
    statusUpdateFailed: "பயனர் நிலையை புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    confirmDelete: "\"{{userName}}\" பயனரை நீக்க விரும்புகிறீர்களா? இந்த செயலை மாற்ற முடியாது.",
    deleteUser: "பயனரை நீக்கு",
    deleteSuccess: "பயனர் \"{{userName}}\" வெற்றிகரமாக நீக்கப்பட்டது.",
    deleteFailed: "பயனரை நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    showingRecords: "{{total}} பயனர்களில் {{start}}-{{end}} காட்டப்படுகிறது",
    firstPage: "முதல் பக்கம்",
    previousPage: "முந்தைய பக்கம்",
    nextPage: "அடுத்த பக்கம்",
    lastPage: "கடைசி பக்கம்",

    createNewUser: "புதிய பயனரை உருவாக்கு",
    addNewTeamMember: "உங்கள் வணிகத்திற்கு ஒரு புதிய குழு உறுப்பினரைச் சேர்க்கவும்",
    backToUsers: "பயனர்களுக்குத் திரும்பு",
    
    basicInformation: "அடிப்படை தகவல்",
    basicInformationDesc: "பயனர் பற்றிய அடிப்படை விவரங்களை வழங்கவும்",
    profilePicture: "சுயவிவர படம்",
    profilePictureDesc: "சுயவிவர படத்தைப் பதிவேற்றவும் (விருப்பமான)",
    accountSettings: "கணக்கு அமைப்புகள்",
    accountSettingsDesc: "பயனர் பங்கு மற்றும் உள்நுழைவு நற்சான்றிதழ்களை கட்டமைக்கவும்",
    shopAssignment: "கடை ஒதுக்கீடு",
    shopAssignmentDesc: "குறிப்பிட்ட கடைகளுக்கு பயனரை ஒதுக்கவும் (விருப்பமான)",
    warehouseAssignment: "கிடங்கு ஒதுக்கீடு",
    warehouseAssignmentDesc: "குறிப்பிட்ட கிடங்குகளுக்கு பயனரை ஒதுக்கவும் (விருப்பமான)",
    
    fullName: "முழுப் பெயர்",
    fullNamePlaceholder: "முழுப் பெயரை உள்ளிடுங்கள்",
    emailAddress: "மின்னஞ்சல் முகவரி",
    emailPlaceholder: "மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
    phoneNumber: "தொலைபேசி எண்",
    phonePlaceholder: "தொலைபேசி எண்ணை உள்ளிடுங்கள்",
    employeeNumber: "பணியாளர் எண்",
    employeeNumberPlaceholder: "பணியாளர் எண்ணை உள்ளிடுங்கள்",
    address: "முகவரி",
    addressPlaceholder: "முகவரியை உள்ளிடுங்கள்",
    birthday: "பிறந்தநாள்",
    userRole: "பயனர் பங்கு",
    selectRole: "ஒரு பங்கைத் தேர்ந்தெடுக்கவும்",
    password: "கடவுச்சொல்",
    passwordPlaceholder: "கடவுச்சொல்லை உள்ளிடுங்கள்",
    confirmPassword: "கடவுச்சொல்லை உறுதிப்படுத்து",
    confirmPasswordPlaceholder: "கடவுச்சொல்லை உறுதிப்படுத்து",
    accountIsActive: "கணக்கு செயலில் உள்ளது",
    defaultShop: "இயல்புநிலை கடை",
    selectDefaultShop: "இயல்புநிலை கடையைத் தேர்ந்தெடுக்கவும்",
    defaultWarehouse: "இயல்புநிலை கிடங்கு",
    selectDefaultWarehouse: "இயல்புநிலை கிடங்கைத் தேர்ந்தெடுக்கவும்",
    
    clickToUpload: "சுயவிவர படத்தைப் பதிவேற்ற கிளிக் செய்யவும்",
    profilePictureFormats: "PNG, JPG, WEBP 5MB வரை",
    
    nameRequired: "பெயர் தேவை",
    emailRequired: "மின்னஞ்சல் தேவை",
    invalidEmail: "தயவுசெய்து சரியான மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
    emailTaken: "இந்த மின்னஞ்சல் முகவரி ஏற்கனவே எடுக்கப்பட்டுள்ளது",
    emailAvailable: "மின்னஞ்சல் கிடைக்கிறது",
    roleRequired: "தயவுசெய்து ஒரு பயனர் பங்கைத் தேர்ந்தெடுக்கவும்",
    passwordRequired: "கடவுச்சொல் தேவை",
    passwordMinLength: "கடவுச்சொல் குறைந்தது 6 எழுத்துகளாக இருக்க வேண்டும்",
    confirmPasswordRequired: "தயவுசெய்து உங்கள் கடவுச்சொல்லை உறுதிப்படுத்துங்கள்",
    passwordsDoNotMatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
    invalidPhone: "தயவுசெய்து சரியான தொலைபேசி எண்ணை உள்ளிடுங்கள்",
    defaultShopRequired: "கடைகள் ஒதுக்கப்படும்போது தயவுசெய்து ஒரு இயல்புநிலை கடையைத் தேர்ந்தெடுக்கவும்",
    defaultWarehouseRequired: "கிடங்குகள் ஒதுக்கப்படும்போது தயவுசெய்து ஒரு இயல்புநிலை கிடங்கைத் தேர்ந்தெடுக்கவும்",
    invalidProfilePictureFormat: "சுயவிவர படம் PNG, JPG, JPEG, அல்லது WEBP வடிவத்தில் இருக்க வேண்டும்",
    profilePictureTooLarge: "சுயவிவர படக் கோப்பு அளவு 5MB க்கும் குறைவாக இருக்க வேண்டும்",
    
    loadingData: "தரவு ஏற்றப்படுகிறது...",
    loadingDataDesc: "தேவையான தகவல்களைப் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    
    createUser: "பயனரை உருவாக்கு",
    
    userCreatedSuccess: "பயனர் \"{{userName}}\" வெற்றிகரமாக உருவாக்கப்பட்டது!",
    failedToCreateUser: "பயனரை உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    failedToLoadData: "தேவையான தரவை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",

    // Edit User specific translations
    editUser: "Edit User",
    updateUser: "Update User", 
    updateTeamMember: "Update team member details and permissions",
    changePassword: "Change Password",
    loadingUser: "Loading User...",
    loadingUserDesc: "Please wait while we fetch the user data.",
    userNotFound: "User not found. It may have been deleted.",
    failedToLoadUser: "Failed to load user data. Please try again.",
    noChangesToSave: "No changes have been made to save.",
    userUpdatedSuccess: "User '{{userName}}' updated successfully!",
    failedToUpdate: "Failed to update user. Please try again.",
    confirmDiscardChanges: "You have unsaved changes. Are you sure you want to leave without saving?",
    discardChanges: "Discard Changes",
    noChanges: "No Changes",
    unsavedChanges: "Unsaved Changes",
}